import React from 'react'
import { Helmet } from "react-helmet";

function No_Permission() {
  return (
    <>
        <Helmet>
            <title>Oops</title>
        </Helmet>
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">

            <div className="error-page">
                <h2 className="headline text-danger"> Oops!</h2>
                <div className="error-content">
                    <h3><i className="fas fa-exclamation-triangle text-danger"></i>Something went wrong.</h3>
                    <p>
                    <b>Timesheet</b> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                    </p>
                    
                </div>
                {/* /.error-content */}
                </div>


            </section>
        </div>
    </>
  )
}

export default No_Permission